import api from '@common/api';

export const orderExport = async (params) => {
  return api.post('/stock/in/order/export', params);
};

/**
 * @description 堆场司机管理-列表
 * @author ZhangYù
 * @date 10/06/2022
 * @export
 * @param {*} params
 * @return {*}
 */
export const fetchStockDriver = ( params ) => ({
  url: '/stock/driver',
  params,
})

// type params {
//   ids: string
// }

/**
 * @description 堆场司机管理-操作-加入黑名单
 * @author ZhangYù
 * @date 10/06/2022
 * @export
 * @param {params} params
 * @return {*}
 */
export function InBlackList (params) {
  return api.put( "/stock/driver/in_blacklist", params )
}


/**
 * @description 堆场司机管理-操作-移出黑名单
 * @author ZhangYù
 * @date 10/06/2022
 * @export
 * @param {params} params
 * @return {*}
 */
export function OutBlackList ( params ) {
  return api.put( "/stock/driver/out_blacklist", params )
}

/**
 * @description 根据箱子信息-获取可选堆场司机
 * @author ZhangYù
 * @date 10/06/2022
 * @export
 * @param {*} s
 * @return {*}
 */
export function fetchStockUseDriver(s) {
  return {
    url: '/stock/driver/use_driver',
    params: { s }
  }
}

/**
 * @description 获取司机详情
 * @author ZhangYù
 * @date 13/06/2022
 * @param {number} id
 * @export
 * @return {*}
 */
export function getStockDriver(id) {
  return {
    url: `/stock/driver/${id}`,
  }
}

/**
 * @description 添加司机
 * @author ZhangYù
 * @date 13/06/2022
 * @param {any} data
 * @export
 * @return {*}
 */
export function addStockDriver(data) {
  return {
    url: `/stock/driver`,
    method: 'POST',
    data
  }
}

/**
 * @description 编辑司机
 * @author ZhangYù
 * @date 13/06/2022
 * @param {any} data
 * @export
 * @return {*}
 */
export function editStockDriver( id, data ) {
  return {
    url: `/stock/driver/${id}`,
    method: 'PUT',
    data
  }
}
